import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnMam = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_mama',
      key: 'num_registro_mama',
      width: 170,
      sorter: (a, b) => a.num_registro_mama - b.num_registro_mama,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },
    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => b.completo - a.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },

    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        // console.log('data in table :>> ', data);

        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },
    // {
    //   title: 'Número do paciente',
    //   dataIndex: 'id_avc',
    //   key: 'id_avc',
    //   width: 100,
    // },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_mama',
      key: 'dn_mama',
      width: 120,
    },

    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_mama_descritivo',
      key: 'convenio_mama',
      width: 120,
    },

    {
      title: 'Peso da paciente (Kg)',
      dataIndex: 'peso_mama',
      key: 'peso_mama',
      width: 110,
    },

    {
      title: 'Altura da paciente (cm)',
      dataIndex: 'altura_mama',
      key: 'altura_mama',
      width: 110,
    },

    {
      title: 'Índice de Massa Corporal',
      dataIndex: 'imc_mama',
      key: 'imc_mama',
      width: 140,
    },

    {
      title:
        'Histórico de Acidente Vascular Cerebral (AVC) ou Ataque Isquêmico Transitório (AIT)',
      dataIndex: 'avc_mama_descritivo',
      key: 'avc_mama',
      width: 210,
    },

    {
      title: 'Histórico de Infarto Agudo do Miocárdio (IAM)',
      dataIndex: 'iam_mama_descritivo',
      key: 'iam_mama',
      width: 190,
    },

    {
      title: 'Diabetes Mellitus',
      dataIndex: 'dm_mama_descritivo',
      key: 'dm_mama',
      width: 140,
    },

    {
      title: 'Doença Autoimune em uso atual de imunomoduladores',
      dataIndex: 'autoimune_mama_descritivo',
      key: 'autoimune_mama',
      width: 210,
    },

    {
      title: 'Tabagismo atual (até imediatamente antes da internação atual)',
      dataIndex: 'tabagismo_mama_descritivo',
      key: 'tabagismo_mama',
      width: 240,
    },

    {
      title: 'Paciente com câncer de mama metastático',
      dataIndex: 'metastase_mama_descritivo',
      key: 'metastase_mama',
      width: 180,
    },

    {
      title: 'Paciente com câncer de mama inflamatório',
      dataIndex: 'ca_inflamatorio_mama_descritivo',
      key: 'ca_inflamatorio_mama',
      width: 180,
    },

    {
      title:
        'Paciente realizou biópsia de fragmento (core biopsy) antes da cirurgia de mama',
      dataIndex: 'biopsia_mama_descritivo',
      key: 'biopsia_mama',
      width: 210,
    },

    {
      title: 'Número de focos',
      dataIndex: 'focos_biopsia_mama',
      key: 'focos_biopsia_mama',
      width: 140,
    },

    {
      title: 'Identificação/análise de margens',
      dataIndex: 'margens_bipsia_mama',
      key: 'margens_bipsia_mama',
      width: 160,
    },

    {
      title: 'Avaliação da expressão de PR e ER, HER2 e Ki67',
      dataIndex: 'expressao_biopsia_mama',
      key: 'expressao_biopsia_mama',
      width: 180,
    },

    {
      title: 'Estadiamento clínico axilar pré-operatório positivo',
      dataIndex: 'estad_clinico_mama_descritivo',
      key: 'estad_clinico_mama',
      width: 210,
    },

    {
      title: 'Data da chegada na instituição',
      dataIndex: 'entrada_data_mama',
      key: 'entrada_data_mama',
      width: 180,
    },

    {
      title: 'Hora da chegada na instituição',
      dataIndex: 'entrada_hora_mama',
      key: 'entrada_hora_mama',
      width: 180,
    },

    {
      title: 'Data do procedimento cirúrgico',
      dataIndex: 'cirurgia_data_mama',
      key: 'cirurgia_data_mama',
      width: 180,
    }, //

    {
      title: 'Procedimento cirúrgico realizado',
      dataIndex: 'cirurgia_tipo_mama_descritivo',
      key: 'cirurgia_tipo_mama',
      width: 280,
    }, //

    {
      title:
        'Realizada pesquisa de linfonodo sentinela durante a cirurgia de mama',
      dataIndex: 'sentinela_mama_descritivo',
      key: 'sentinela_mama',
      width: 260,
    }, //

    {
      title: 'Paciente recebeu reconstrução mamária imediata',
      dataIndex: 'reconstrucao_mama_descritivo',
      key: 'reconstrucao_mama',
      width: 220,
    }, //

    {
      title: 'Motivo da não-realização da reconstrução mamária imediata',
      dataIndex: 'nao_realizacao_mama_descritivo',
      key: 'nao_realizacao_mama',
      width: 220,
    }, //

    {
      title: 'Descrição do número de focos',
      dataIndex: 'focos_cirurgia_mama_descritivo',
      key: 'focos_cirurgia_mama',
      width: 180,
    }, //

    {
      title:
        'Descrição de (linfonodos removidos, linfonodos positivos para câncer com células malignas,  presença ou ausência de extravasamento capsular, células tumorais isoladas )',
      dataIndex: 'linfonodos_cirurgia_mama_descritivo',
      key: 'linfonodos_cirurgia_mama',
      width: 310,
    }, //

    {
      title: 'Tipo e grau histológico do tumor',
      dataIndex: 'grau_tumor_mama_descritivo',
      key: 'grau_tumor_mama',
      width: 180,
    }, //

    {
      title: 'Identificação/análise de margens',
      dataIndex: 'margens_cirurgia_mama_descritivo',
      key: 'margens_cirurgia_mama',
      width: 180,
    }, //

    {
      title: 'Avaliação da presença ou ausência de invasão linfovascular',
      dataIndex: 'invasao_linfo_cirurgia_mama_descritivo',
      key: 'invasao_linfo_cirurgia_mama',
      width: 240,
    }, //

    {
      title: 'Avaliação da expressão de PR e ER, HER2 e Ki67',
      dataIndex: 'expressao_cirurgia_mama_descritivo',
      key: 'expressao_cirurgia_mama',
      width: 180,
    }, //

    {
      title: 'Laudo anatomopatológico da cirurgia',
      dataIndex: 'tnm_pos_mama_descritivo',
      key: 'tnm_pos_mama',
      width: 190,
    }, //

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_mama_descritivo',
      key: 'covid_mama',
      width: 180,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_mama_descritivo',
      key: 'saida_motivo_mama',
      width: 140,
    }, //

    {
      title: 'Data da saída hospitalar',
      dataIndex: 'saida_data_mama',
      key: 'saida_data_mama',
      width: 110,
    }, //

    {
      title: 'Hora da saída hospitalar',
      dataIndex: 'saida_hora_mama',
      key: 'saida_hora_mama',
      width: 170,
    }, //
  ];
};

export default columnMam;
